import { AppBar, Stack, styled, Toolbar, Typography } from "@mui/material";
import React from "react";
import strings from "../helper/strings";
import { Product } from "../interfaces/products";
import GButtonContained from "./elements/GButtonContained";
import GButtonOutlined from "./elements/GButtonOutlined";
import Cookies from "universal-cookie";
import payKeys from "../config/pay-keys";

interface FooterProps {
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlIframe: React.Dispatch<React.SetStateAction<string>>;
  product: Product | undefined;
  executeScroll: () => void;
}

function Footer(props: FooterProps) {
  const cookies = new Cookies();

  function sendToPay() {
    props.setUrlIframe(
      `${payKeys}/?product-id=${
        props.product?.productId
      }&catalog-id=${props.product?.catalogId}&manager-id=${cookies.get(
        "refferer"
      )}&gooly=${cookies.get("gooly")}`
    );
    props.setOpenPayPage(true);
  }
  const StyleToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "center",
    backgroundColor: "white",
    paddingBlock: 10,
  });
  return (
    <AppBar position="sticky" color="primary" sx={{ top: "auto", bottom: 0 }}>
      <StyleToolbar>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ direction: "rtl" }}
        >
          <Typography
            sx={{
              color: "black",
              direction: "rtl",
              fontSize: { xs: 12, sm: 18 },
              alignSelf: "center",
            }}
          >
            {props.product?.template.header}{" "}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Poppins,Arial",
              color: "black",
              fontWeight: 700,
              fontSize: { xs: 18, sm: 30 },
              alignSelf: "center",
              px: 2,
            }}
          >
            {props.product
              ? `₪${Number(props.product?.["product.price"]).toLocaleString()}`
              : ""}{" "}
          </Typography>
          <Stack
            direction="row"
            sx={{
              "& > :not(style)": {
                m: 1,
              },
            }}
          >
            <GButtonContained
              handleAction={sendToPay}
              width={100}
              text={strings.main.payOnline}
            />
            <GButtonOutlined
              handleAction={() => props.executeScroll()}
              width={100}
              color="black"
              text={strings.main.leftMessage}
            />
          </Stack>
        </Stack>
      </StyleToolbar>
    </AppBar>
  );
}

export default Footer;
